// seo
import { Route, Routes, useNavigate } from "react-router";
// container
import { ToastContainer } from "react-toastify";
import { RoutesUser } from "../../features/routes/userRouts";
// component
import Menu from "../menu/menu";
// @ts-ignore
import Cookies from "js-cookie";
// hook
import { useEffect } from "react";
const AdminBase = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!Cookies.get('agent_token')) {
            navigate('/404');
        }
        document.getElementById('pages-header')?.classList.remove('d-none');
    }, [navigate]);
    if (Cookies.get('agent_token')) {
        return (
            <>
                <main className="container">
                    <div className="row py-3 gy-4 mt-2">
                        <div className="col-lg-3">
                            <Menu routes={RoutesUser} />
                        </div>
                        <div className="col-lg-9">
                            <Routes>
                                {RoutesUser.map((link) => (
                                    <Route key={link.address} path={link.address} element={link.component} />
                                ))}
                            </Routes>
                        </div>
                    </div>
                    <ToastContainer />
                </main>
            </>
        )
    }
}

export default AdminBase;